import { EntityModel } from '@/interfaces'
import {
  ALL_TIERS_QUERY,
  CREATE_TIER_MUTATION,
  DELETE_TIER_MUTATION,
  FORCE_DELETE_TIER_MUTATION,
  SINGLE_TIER_QUERY,
  UPDATE_TIER_MUTATION,
} from './graphql'

const bargainTierModel: EntityModel = {
  name: 'tier',
  namePlural: 'tiers',
  uniqueName: 'bargainTier',
  uniqueNamePlural: 'bargainTiers',
  path: 'config/ratio/bargain/tier',
  baseUrl: '/config/ratio/bargain/tiers',
  translationPrefix: 'entities:bargainTier.',
  getDisplayName: (values: any) => {
    return `${values.fromPrice}.- | ${values.discount}.-`
  },
  gql: {
    getAll: ALL_TIERS_QUERY,
    getSingle: SINGLE_TIER_QUERY,
    create: CREATE_TIER_MUTATION,
    update: UPDATE_TIER_MUTATION,
    delete: DELETE_TIER_MUTATION,
    forceDelete: FORCE_DELETE_TIER_MUTATION,
  },
  attributes: {
    fromPrice: {
      name: 'fromPrice',
      label: 'entities:bargainTier.attributes.fromPrice.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'number',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'number',
        },
      ],
    },
    discount: {
      name: 'discount',
      label: 'entities:bargainTier.attributes.discount.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'number',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'number',
        },
      ],
    },
  },
}

export default bargainTierModel
